import { useState, useEffect, useCallback } from "react";
import GamificationService from "../../../../services/gamification_service";
import { useTenant } from "../../../../hooks/useTenant";
import { gamificationDefaults } from "../../../../models/gamification/gamificationDefaults";
import { toast } from 'react-toastify';

export const useGamificationSettings = () => {
    const { idTenant, user } = useTenant();

    const [data, setData] = useState(gamificationDefaults);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    const loadData = useCallback(async () => {
        if (!idTenant) return;
        setLoading(true);
        try {
            const result = await GamificationService.getSettings(idTenant);
            if (result) {
                setData(result);
            } else {
                // Se o tenant for novo e não tiver gamificação, salva os padrões do sistema
                await GamificationService.saveSettings(gamificationDefaults, idTenant, user);
                setData(gamificationDefaults);
            }
        } catch (error) {
            console.error("Erro ao carregar configurações de gamificação:", error);
            toast.error("Não foi possível carregar as configurações de Gamificação.");
        } finally {
            setLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idTenant]);

    useEffect(() => {
        loadData();
    }, [loadData]);

    const handleSubmit = async (values) => {
        if (!idTenant) return false;

        setSaving(true);
        try {
            await GamificationService.saveSettings(values, idTenant, user);
            toast.success("Configurações salvas com sucesso!");
            setData(values);
            return true;
        } catch (error) {
            console.error("Erro ao salvar configurações de gamificação:", error);
            toast.error(error.message || "Erro ao salvar as configurações.");
            return false;
        } finally {
            setSaving(false);
        }
    };

    return {
        data,
        loading,
        saving,
        actions: {
            handleSubmit
        }
    };
};
